import { SimpleGuard } from 'interfaces/guards'
import { GetCCPaymentMethodsAction } from 'components/features/creditCard/creditCardStore/actions'


export const ccPaymentMethodsGuard: SimpleGuard = {
  name: `Credit Card Payment Methods Guard`,
  checker: (state) => {
    return state.data.creditCard.paymentMethods !== null
  },
  loader: (dispatch) => {
    dispatch(new GetCCPaymentMethodsAction())
  },
}
